import { chartConfig } from "../chart.commonConfig";
import { PDF_CONSTANT } from "../../../../constant";
import { chartsLoadedAction } from "../../../../actions/reports.action";

export const ISSUES_WITH_PMG_HELPER = data => {
  const PieChartConfig = {
    chart: {
      ...chartConfig.chart,
      type: "pie",
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      marginLeft: 500,
      className: "chart-background",
      events: {
        load: () => {
          chartsLoadedAction({
            type: PDF_CONSTANT.FIRST_PAGE.THIRD._SUCCESS
          });
        }
      }
    },
    title: {
      ...chartConfig.title,
      align: "center",
      text: "TYPES OF ISSUE WITH PMG",
      y: 25
    },
    plotOptions: {
      pie: {
        showInLegend: true,
        point: {
          events: {
            legendItemClick: function() {
              this.slice(null);
              return false;
            }
          }
        }
      },
      series: {
        animation: false,
        startAngle: 90,
        events: {
          legendItemClick: function(event) {
            event.preventDefault();
          }
        }
      }
    },
    series: [
      {
        name: "Issues",
        // colorByPoint: true,
        data: [],
        dataLabels: {
          enabled: true,
          //format: `<b style="color:{point.color}">{point.name}<br><span style="color:{point.color}">{point.percentage:.1f} %</span></b>`,
          format: `<span style="color:{point.color}">{point.percentage:.1f} %</span>`
        }
      }
    ],
    legend: {
      align: "left",
      verticalAlign: "top",
      layout: "vertical",
      x: 0,
      y: 40,
      symbolPadding: 0,
      symbolWidth: 0.1,
      symbolHeight: 0.1,
      symbolRadius: 0,
      useHTML: true,
      symbolWidth: 0,
      labelFormatter: function() {
        return `<div style="background-color: ${
          this.color
        }" class="issueCategoryLegend">${this.name}</div>`;
      },
      floating: false
    },
    tooltip: {
      shared: true,
      // pointFormat: `{series.name}: <b>{point.y}</b><br/>`
      formatter: function() {
        return `
                <b>${this.key}</b><br />
                <b>Issues: ${this.y.toFixed(2)}</b>
              `;
      }
    }
  };

  // set data
  PieChartConfig.series[0]["data"] = data.map(val => {
    return { name: val.issueCategory, y: val.percentage };
  });
  return PieChartConfig;
};
